export default __webpack_public_path__ + "static/media/plus-enter-data.e35a1ba1.svg";